export default "__VITE_ASSET__Bk3530lS__"